module.exports = __webpack_public_path__ + "img/MANHEIM.af9425a2.png";